import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EpostersService {

  eposters = [
    {
        id:1, name:"",
        main_title: "Bloc auriculo ventriculaire complet faisant découvrir une double \r\ndiscordance cardiaque chez un patient de 25 ans",
        all_names: "R. Jennane, S. Hilal, F. Anaelle, H. Lokman, I. Fellat, R. Amri",
        service: "Service de cardiologie B, hôpital maternité Souissi , Rabat", 
        img:"assets/imgs/eposters/images/poster-01-01.jpg", pdf:"assets/imgs/eposters/pdfs/poster-01-01.pdf", 
    },
    {
        id:1, name:"",
        main_title: "MYOCARDITE SEGMENTAIRE AU COURS DU SYNDROME DE CHURG ET STRAUSS",
        all_names: "O.Hdioud , R.Jennane , R.Fellat,N.Fellat",
        service: "Service de cardiologie A CHU IBN SINA", 
        img:"assets/imgs/eposters/images/poster-01-02.jpg", pdf:"assets/imgs/eposters/pdfs/poster-01-02.pdf", 
    },
    {
        id:1, name:"",
        main_title: "A CASE REPORT ABOUT A LARGE RIGHT VENTRICULE METASTASIS OF MELANOMA",
        all_names: "W.Louizi , H. Belhoussine , N. Bourzine , N. Doghmi , M. Cherti",
        service: "Cardiology B department CHU Ibn Sina", 
        img:"assets/imgs/eposters/images/poster-01-03.jpg", pdf:"assets/imgs/eposters/pdfs/poster-01-03.pdf", 
    },
    {
        id:2, name:"",
        main_title: "SYNDROME DE MEADOWS : A PROPOS D’UN CAS",
        all_names: "O.Hdioud , R.Jennane , R.Fellat,N.Fellat",
        service: "Service de cardiologie A CHU IBN SINA", 
        img:"assets/imgs/eposters/images/poster-02.jpg", pdf:"assets/imgs/eposters/pdfs/poster-02.pdf", 
    },
    {
        id:3, name:"",
        main_title: "IMPACT OF ANEMIA ON THE SHORT TERM MORTALITY OF PATIENTS WITH ACUTE CORONARY SYNDROME",
        all_names: "A. KHERRAF, S. ZENOUAKI, M.ElMOUSAID , M. BOUZIANE, A. DRIGHIL, R. HABBAL",
        service: "Department of Cardiology Casablanca", 
        img:"assets/imgs/eposters/images/poster-03.jpg", pdf:"assets/imgs/eposters/pdfs/poster-03.pdf", 
    },
    {
        id:4, name:"",
        main_title: "CARACTERISTIQUES DE LA CORONARROPATHIE CHEZ LA FEMME",
        all_names: "A.Kherraf , M. Abdulhakeem , M. ElMousaid , H. Adnane, A. Drighil , R. Habbal",
        service: "Service de Cardiologie CHU Ibn Rochd de Casablanca", 
        img:"assets/imgs/eposters/images/poster-04.jpg", pdf:"assets/imgs/eposters/pdfs/poster-04.pdf", 
    },
    {
        id:5, name:"",
        main_title: "Prevalence and prognosis of anemia in patients with chronic heart failure about 2000 cases",
        all_names: "A. Kherraf , H. Mechal , M. ElMousaid , M. Haboub , A. Drighill , R. Habbal",
        service: "Cardiology department CHU Ibn Rochd Casablanca", 
        img:"assets/imgs/eposters/images/poster-05.jpg", pdf:"assets/imgs/eposters/pdfs/poster-05.pdf", 
    },
    {
        id:6, name:"",
        main_title: "LE SYNDROME METABOLIQUE CHEZ LES PATIENTS HYPERTENDUS DANS UNE POPULATION MAROCAINE",
        all_names: "A.Kherraf , S. Zenouaki , M. Abdulhakeem , A. Drighil , R. Habbal",
        service: "Service de Cardiologie CHU Ibn Rochd de Casablanca, Maroc", 
        img:"assets/imgs/eposters/images/poster-06.jpg", pdf:"assets/imgs/eposters/pdfs/poster-06.pdf", 
    },
    {
        id:7, name:"",
        main_title: "Atteinte athéromateuse carotidienne chez les diabétiques asymptomatiques et intérêt du dépistage échographique",
        all_names: "A.Kherraf , M. Abdulhakeem , M. ElMousaid , H. Adnane, A. Drighil , R. Habbal",
        service: "Service de Cardiologie CHU Ibn Rochd de Casablanca", 
        img:"assets/imgs/eposters/images/poster-07.jpg", pdf:"assets/imgs/eposters/pdfs/poster-07.pdf", 
    },
    {
        id:8, name:"",
        main_title: "PROFIL DES PATIENTS ATTEINTS DE SYNDROME CORONARIEN SANS SUS DECALAGE AVEC OU SANS SYNDROME METABOLIQUE",
        all_names: "A. Kherraf , M. ELMousaid , A. ElAmraoui , A. Drighil , R. Habbal",
        service: "Service de Cardiologie, CHU Ibn Rochd , Casablanca, Maroc", 
        img:"assets/imgs/eposters/images/poster-08.jpg", pdf:"assets/imgs/eposters/pdfs/poster-08.pdf", 
    },
    {
        id:9, name:"",
        main_title: "PROFIL THERAPEUTIQUE DE L’HYPERTENSION ARTERIELLE ESSENTIELLE : EXPERIENCE DU SERVICE DE CARDIOLOGIE CASABLANCA",
        all_names: "A.Kherraf , S. Zenouaki , M. Abdulhakeem , A. Drighil , R. Habbal",
        service: "Service de Cardiologie CHU Ibn Rochd de Casablanca, Maroc", 
        img:"assets/imgs/eposters/images/poster-09.jpg", pdf:"assets/imgs/eposters/pdfs/poster-09.pdf", 
    },
    {
        id:10, name:"",
        main_title: "Characterestics of Chronic Heart Failure (CHF) among hypertensive patients",
        all_names: "A.Kherraf , M. Abdulhakeem , S. Zenouaki , A. Drighil , R. Habbal",
        service: "Cardiology department , CHU Ibn Rochd Casablanca", 
        img:"assets/imgs/eposters/images/poster-10.jpg", pdf:"assets/imgs/eposters/pdfs/poster-10.pdf", 
    },
    {
        id:11, name:"",
        main_title: "CORRELATION BETWEEN DIASTOLIC FUNCTION AND LOWER GLS IN HYPERTENSIVE PATIENTS",
        all_names: "A.Kherraf, S. Zenouaki , H. Mechal , A. Drighil , R. Habbal",
        service: "Cardiology department CHU Ibn Rochd Casablanca", 
        img:"assets/imgs/eposters/images/poster-11.jpg", pdf:"assets/imgs/eposters/pdfs/poster-11.pdf", 
    },
    {
        id:17, name:"",
        main_title: "LAUBRY PEZZI SYNDROME WITH AORTA PULMONARY ARTERY FISTULA : A RARE ASSOCIATION",
        all_names: "A.ELOUARDI, S.BOULMAKOUL, A.MAJDOUB, M.MESSOUAK",
        service: "SERVICE DE CHIRURGIE CARDIO- VASCULAIRE, CHU HASSAN II, FES, MAROC", 
        img:"assets/imgs/eposters/images/poster-17.jpg", pdf:"assets/imgs/eposters/pdfs/poster-17.pdf", 
    },
    {
        id:18, name:"",
        main_title: "Impact of left bundle branch block on heart failure with reduced ejection fraction symptoms and outcomes : experience of a Moroccan centre",
        all_names: "H.MECHAL,M.El MOUSSAID, A.BOUTALEB, K.MOUNAOUIR, M.BENOUNA, A.DRIGHIL,L.AZZOUZI, R.HABBAL",
        service: "Cardiology Department, Hospital University Ibn Rochd , Casablanca, Morocco", 
        img:"assets/imgs/eposters/images/poster-18.jpg", pdf:"assets/imgs/eposters/pdfs/poster-18.pdf", 
    },
    {
        id:19, name:"",
        main_title: "Impact of sodium level on the prognosis of 3412 patients with congestive heart failure",
        all_names: "H.MECHAL, M.El MOUSSAID, A.BOUTALEB, K.MOUNAOUIR, M.BENOUNA, A.DRIGHIL,L.AZZOUZI, R.HABBAL",
        service: "Cardiology Department, Hospital University Ibn Rochd , Casablanca, Morocco", 
        img:"assets/imgs/eposters/images/poster-19.jpg", pdf:"assets/imgs/eposters/pdfs/poster-19.pdf", 
    },
    {
        id:20, name:"",
        main_title: "Prevalence and prognostic impact of Anemia on congestive heart failure (CHF) in a Moroccan university hospital: about 3412 patients.",
        all_names: "H.MECHAL, A.BOUTALEB,M.ElMOUSSAID , K.MOUNAOUIR, M.BENOUNA, A.DRIGHIL,L.AZZOUZI, R.HABBAL",
        service: "Cardiology Department, Hospital University Ibn Rochd , Casablanca, Morocco", 
        img:"assets/imgs/eposters/images/poster-20.jpg", pdf:"assets/imgs/eposters/pdfs/poster-20.pdf", 
    },
    {
        id:21, name:"",
        main_title: "Impact of obesity on chronic heart failure with reduced ejection fraction features and outcomes : experience of a Moroccan centre",
        all_names: "H.MECHAL,M.ElMOUSSAID , A.BOUTALEB, K.MOUNAOUIR, M.BENOUNA, A.DRIGHIL,L.AZZOUZI, R.HABBAL",
        service: "Cardiology Department, Hospital University Ibn Rochd , Casablanca, Morocco", 
        img:"assets/imgs/eposters/images/poster-21.jpg", pdf:"assets/imgs/eposters/pdfs/poster-21.pdf", 
    },
    {
        id:22, name:"",
        main_title: "Atrial fibrillation versus sinus rhythm in congestive heart failure : A Moroccan experience of 3412 patients",
        all_names: "H.MECHAL, M.HABOUB, A.BOUTALEB,M.ElMOUSSAID , K.MOUNAOUIR,M.BENOUNA, A.DRIGHIL, L.AZZOUZI, R.HABBAL",
        service: "Cardiology Department, Hospital University Ibn Rochd , Casablanca, Morocco", 
        img:"assets/imgs/eposters/images/poster-22.jpg", pdf:"assets/imgs/eposters/pdfs/poster-22.pdf", 
    },
    {
        id:23, name:"",
        main_title: "Manifestations cardiologiques lors de l'envenimation scorpionique",
        all_names: "H.MECHAL, A.KHERRAF, K.MOUNAOUIR, A.MOUKHLISS, M.BENOUNA, A.DRIGHIL, L.AZZOUZI, R.HABBAL",
        service: "Cardiology Department, Hospital University Ibn Rochd , Casablanca, Morocco", 
        img:"assets/imgs/eposters/images/poster-23.jpg", pdf:"assets/imgs/eposters/pdfs/poster-23.pdf", 
    },
    {
        id:24, name:"",
        main_title: "MID VENTRICULAR TAKOTSUBO CARDIOMYOPATHY: TWO CASE REPORTS AND REVIEW OF THE LITERATURE.",
        all_names: "Dr Kaddaf Sofia , Dr Nadif Maryam . Dr Adolphe Kasango , Dr Pascal Goube",
        service: "Department of cardiology of Sud Francilien Hospital Corbeil Essones", 
        img:"assets/imgs/eposters/images/poster-24.jpg", pdf:"assets/imgs/eposters/pdfs/poster-24.pdf", 
    },
    {
        id:25, name:"",
        main_title: "Cardiac metastasis of neuroendocrine tumor diagnosed by TEP scan : a case report",
        all_names: "S.KADDAF ,M.NADIF ,S.FAID,N. LOUDIYI .N .MOUINE I.ASFALOU,M. RAISSOUNI ,Z.LAKHAL, A.BENYASS",
        service: "Department of cardiology of Mohammed V Military Hospital of Rabat.", 
        img:"assets/imgs/eposters/images/poster-25.jpg", pdf:"assets/imgs/eposters/pdfs/poster-25.pdf", 
    },
    {
        id:26, name:"",
        main_title: "SYNDROME CORONAIRE AIGU LORS D’UNE INTOXICATION AU MONOXYDE DE CARBONE",
        all_names: "S.AOUAME,A.EZZOUAK ,M.BAYA,A.LAGZIRI,M.BADIDI",
        service: "Service de Cardiologie de l’Hopital Militaire Moulay Ismail", 
        img:"assets/imgs/eposters/images/poster-26.jpg", pdf:"assets/imgs/eposters/pdfs/poster-26.pdf", 
    },
    {
        id:27, name:"",
        main_title: "TOXICITÉ CARDIAQUE APRÈS UN TRAITEMENT AU LONG COURS PAR CHLOROQUINE CHEZ UNE PATIENTE LUPIQUE",
        all_names: "S.AOUAME,A.EZZOUAK ,M.BAYA,A.LAGZIRI,M.BADIDI",
        service: "Service de Cardiologie de lHopital Militaire Moulay Ismail", 
        img:"assets/imgs/eposters/images/poster-27.jpg", pdf:"assets/imgs/eposters/pdfs/poster-27.pdf", 
    },
    {
        id:28, name:"",
        main_title: "Hypertension artérielle au cours des syndromes coronariens aigus",
        all_names: "PB Issanga Maloumbi¹˜²,JR Ibara Onguema¹˜², FB Ekoba Othende¹˜², M El Jamili¹, A Bouzerda²,\r\n A Rbaibi²D Benzarouel¹, S El Karimi¹, L Bendriss², M El Hattoui¹, A Khatouri²",
        service: "¹ Service de Cardiologie et maladies vasculaires du Centre hospitalier et Universitaire de Marrakech\r\n² Service de Cardiologie de l’Hopital militaire Avicennes de Marrakech", 
        img:"assets/imgs/eposters/images/poster-28.jpg", pdf:"assets/imgs/eposters/pdfs/poster-28.pdf", 
    },
    {
        id:29, name:"",
        main_title: "L’index de pression systolique(IPS),marqueur indépendant de sténose coronarienne ?",
        all_names: "PB Issanga Maloumbi,I GANSE,JR Ibara-Onguema,A SAFAA, M El Jamili, D Benzarouel, S El Karimi,M EL HATTAOUI",
        service: "Service de Cardiologie et maladies vasculaires du Centre hospitalier et Universitaire de Marrakech", 
        img:"assets/imgs/eposters/images/poster-29.jpg", pdf:"assets/imgs/eposters/pdfs/poster-29.pdf", 
    },
    {
        id:32, name:"",
        main_title: "Cardiac autotransplantation for repair of left ventricular rupture after mitral valve replacement: case report",
        all_names: "R.MOUNIR*, H.MOKHLIS**, A.A.AMIR*, F.NYA*, A.SEGHROUCHNI*, N.ATMANI*, S.BELLOUIZ*,A.G.HATIM*, I.ASFALOU**, N.MOUINE**, A.BENYASS**, Y. ELBEKKALI*, Y.MOUTAKI ALLAH*, M.AIT HOUSSA*\r\n",
        service: "*SERVICE DE CHIRURGIE CARDIAQUE, HOPITAL MILITAIRE DINSTUCTION MOHAMED V , RABAT\r\n**SERVICE DE CARDIOLOGIE,HOPITAL MILITAIRE DINSTRUCTION MOHAMED V , RABAT", 
        img:"assets/imgs/eposters/images/poster-32.jpg", pdf:"assets/imgs/eposters/pdfs/poster-32.pdf", 
    },
    {
        id:33, name:"",
        main_title: "UN ANÉVRYSME CÉRÉBRAL ROMPU RÉVÉLANT UNE ENDOCARDITE NFECTIEUSE AVEC PERFORATION AORTIQUE: À PROPOS D’UN CAS",
        all_names: "Belhoussine.H, Louizi.W , Lahfidi.A , Zarzur.J , Cherti.M",
        service: "Cardiologie B Hôpital De Maternité CHU Ibn Sina de RABAT", 
        img:"assets/imgs/eposters/images/poster-33.jpg", pdf:"assets/imgs/eposters/pdfs/poster-33.pdf", 
    },
    {
        id:34, name:"",
        main_title: "BBG ISCHEMIQUE : FAUT-IL TOUJOURS S'ATTENDRE A UNE LESION DE L'IVA",
        all_names: "F.Hassan;D.IBRAHIM;L.IBRAHIM;D.ABDOULAYE;B.ABAKAR;Z.LAKHAL",
        service: "CENTRE DE CARDIOLOGIE Hôpital Militaire d’instruction Mohamed V Rabat", 
        img:"assets/imgs/eposters/images/poster-34.jpg", pdf:"assets/imgs/eposters/pdfs/poster-34.pdf", 
    },
    {
        id:35, name:"",
        main_title: "Hypertension artérielle et syndrome dapnée obstructive du sommeil : quel degré de corrélation",
        all_names: "H.NABAWI Y.CHAFAI S.KARIMI M.EL HATTAOUI",
        service: "Service de cardiologie du CHU Mohammed VI Marrakech", 
        img:"assets/imgs/eposters/images/poster-35.jpg", pdf:"assets/imgs/eposters/pdfs/poster-35.pdf", 
    },
    {
        id:36, name:"",
        main_title: "LES FACTEURS COMPORTEMENTAUX AU COEUR DE L’INOBSERVANCE THÉRAPEUTIQUE DES PATIENTS HYPERTENDUS",
        all_names: "Y.CHAFAI H.ROUAM M. EL HATTAOUI",
        service: "Service de cardiologie du CHU Mohammed VI Marrakech", 
        img:"assets/imgs/eposters/images/poster-36.jpg", pdf:"assets/imgs/eposters/pdfs/poster-36.pdf", 
    },
    {
        id:37, name:"",
        main_title: "INERTIE THÉRAPEUTIQUE AU COEUR DE LA PRISE EN CHARGE DE L’HTA PAR LES GÉNÉRALISTES MAROCAINS",
        all_names: "Y.CHAFAI H.ROUAM M. EL HATTAOUI",
        service: "Service de cardiologie du CHU Mohammed VI Marrakech", 
        img:"assets/imgs/eposters/images/poster-37.jpg", pdf:"assets/imgs/eposters/pdfs/poster-37.pdf", 
    },
    {
        id:38, name:"",
        main_title: "Prévalence des effets indésirables des antihypertenseurs chez les patients suivis en ambulatoire pour hypertension artérielle",
        all_names: "H.NABAWI Y.CHAFAI S.KARIMI M.EL HATTAOUI",
        service: "Service de cardiologie du CHU Mohammed VI Marrakech", 
        img:"assets/imgs/eposters/images/poster-38.jpg", pdf:"assets/imgs/eposters/pdfs/poster-38.pdf", 
    },
    {
        id:41, name:"",
        main_title: "MYOCARDIAL INFARCTION AS A RESULT OF POST HEMORRHAGIC\r\nANEMIA IN THE COURSE OF UNKNOWN DIGESTIVE CANCER",
        all_names: "SCADI S 1 , BENZHA MY 2 , ABDELADIM S 1 , EL HARRAS M 1 , BENSAHI I 1 , EL OUARRADI A 1 ,OUALIM S 1 , LAARAJ A 1 , BENYOUSSEF H 2 , MAKANI S 2 , SABRY M 1\r\n",
        service: "1 Department of Cardiology Cheikh Khalifa University Hospital UM6SS\r\n2 Department of Cardiovascular surgery Cheikh Khalifa University Hospital UM6SS", 
        img:"assets/imgs/eposters/images/poster-41.jpg", pdf:"assets/imgs/eposters/pdfs/poster-41.pdf", 
    },
    {
        id:42, name:"",
        main_title: "RICKETTSIOSIS AND CORONARY ARTERY DISEASE: IS THE\r\nASSOCIATION ATHEROSCLEROSIS AND RICKETTSIOSIS FORTUITOUS?",
        all_names: "SCADI S 1 , BENZHA MY 2 , ABDELADIM S 1 , EL HARRAS M 1 , BENSAHI I 1 , EL OUARRADI A 1 , OUALIM S 1 , LAARAJ A 1 , BENYOUSSEF H 2 , MAKANI S 2 , SABRY M 1\r\n",
        service: "1 Department of Cardiology Cheikh Khalifa University Hospital UM6SS\r\n2 Department of Cardiovascular surgery Cheikh Khalifa University Hospital UM6SS", 
        img:"assets/imgs/eposters/images/poster-42.jpg", pdf:"assets/imgs/eposters/pdfs/poster-42.pdf", 
    },
    {
        id:43, name:"",
        main_title: "Un hémopéricarde engageant le pronostic vital, induit par un anticoagulant oral direct",
        all_names: "N.Belharty a ;C.Rhemimet a ;A.Ameur a ;Y.Ouharakate a ;N.Mouine b ;I.Assfalou c ;Z.Lakhal a ;A.Benyass c",
        service: "a:Service des unités de soins intensifs de cardiologie,HMIMV Rabat\r\nb:service des explorations non invasives de cardiologie, HMIMV Rabat\r\nc: service de cardiologie clinique; centre de cardiologie, HMIMV Rabat", 
        img:"assets/imgs/eposters/images/poster-43.jpg", pdf:"assets/imgs/eposters/pdfs/poster-43.pdf", 
    },
    {
        id:44, name:"",
        main_title: "La communication interventriculaire post infarctus : Aspects épidémiologiques ,facteurs prédisposants et revue de la littérature . A propos de 2 cas",
        all_names: "Dr N.LAKTIB ¹ ;Dr O.AITKEJJAT ¹ ; Dr R.BALLOUK ¹ ; Dr K.BERRAG ¹ ; Dr Z.LAHLAFI ¹ ; Dr D.BRITEL ¹ ;\r\n Pr Z.LAKHAL ² ; Pr A.BENYASS ³",
        service: "¹:Unité des soins intensifs de cardiologie de l’Hôpital Militaire d’Instruction Mohammed V Rabat\r\n² : Chef de service de l’unité des soins intensifs de cardiologie de l’Hôpital Militaire d’instruction Mohammed V Rabat\r\n³: Chef du centre de cardiologie de l’Hôpital Militaire d’Instruction Mohammed V Rabat\r\n", 
        img:"assets/imgs/eposters/images/poster-44.jpg", pdf:"assets/imgs/eposters/pdfs/poster-44.pdf", 
    },
    {
        id:45, name:"",
        main_title: "Spondylodiscitis revealing an infective endocarditis , an uncommon septic metastasis: A report of 2 cases.",
        all_names: "Dr N,LAKTIB;Dr Z,MOUHIB; Dr M,BOUMAAZ; Dr A,ZAAIMI; Pr N,MOUINE ¹ ; Pr I,ASFALOU ² ; Pr BENYASS ³",
        service: "¹Head of the\r\ncardiology clinic of the cardiology center of the Mohammed V Military Teaching Hospital\r\n²: Head of the\r\nnoninvasive cardiac exploration department of the cardiology center of the Mohammed V Military Teaching Hospital\r\n³:Head of the\r\ncardiology center of the Mohammed V Military Teaching Hospital", 
        img:"assets/imgs/eposters/images/poster-45.jpg", pdf:"assets/imgs/eposters/pdfs/poster-45.pdf", 
    },
    {
        id:46, name:"",
        main_title: "Essential hypertension pathogenesis : Merely a sympathetic hyperactivity ? A series of 10 patients",
        all_names: "Dr N,LAKTIB;Dr S,FAID; Dr FZ.FIKRAT; Pr N,MOUINE ¹ ; Pr I,ASFALOU ² ; Pr BENYASS ³",
        service: "¹Head of the cardiology clinic of the cardiology center of the Mohammed V Military Teaching Hospital\r\n²: Head of the\r\nnoninvasive cardiac exploration department of the cardiology center of the Mohammed V Military Teaching Hospital\r\n³:Head of the\r\ncardiology center of the Mohammed V Military Teaching Hospital", 
        img:"assets/imgs/eposters/images/poster-46.jpg", pdf:"assets/imgs/eposters/pdfs/poster-46.pdf", 
    },
    {
        id:47, name:"",
        main_title: "Angiosarcome de l’artère pulmonaire récidivant :",
        all_names: "Z.Eddhima A , H.Faliouni A , N.Loudiyi A , N.Mouine A ,I.Asfalou B ,A.Benyass C",
        service: "A :Service de Cardiologie Clinique, Hôpital Militaire d’Instructions Mohamed V, Rabat\r\nB:Service des explorations cardiologiques, Hôpital Militaire d’Instructions Mohamed V, Rabat\r\nC:Centre de Cardiologie, Hôpital Militaire d’Instructions Mohamed V, Rabat", 
        img:"assets/imgs/eposters/images/poster-47.jpg", pdf:"assets/imgs/eposters/pdfs/poster-47.pdf", 
    },
    {
        id:48, name:"",
        main_title: "Intérêt du dosage du Facteur VIII dans la maladie thromboembolique veineuse",
        all_names: "Z.Eddhima A ,Z.Choho A M.ZikoDésiré A ,N.Belharty A , H.Faliouni A , N.Loudiyi A , N.Mouine\r\n A , I.Asfalou B , A.Benyass C",
        service: "A: Service de Cardiologie Clinique, Hôpital Militaire d’Instructions Mohamed V, Rabat\r\nB: Service des explorations cardiologiques, Hôpital Militaire d’Instructions Mohamed V, Rabat\r\nC: Centre de Cardiologie, Hôpital Militaire d’Instructions Mohamed V, Rabat\r\n", 
        img:"assets/imgs/eposters/images/poster-48.jpg", pdf:"assets/imgs/eposters/pdfs/poster-48.pdf", 
    },
    {
        id:49, name:"",
        main_title: "Endocardite Infectieuse sur Dispositif Électronique Intracardiaque (Pacemakers):\r\nExpérience du service Rythmologie de l’HMIMV",
        all_names: "Z. Laraichi¹, M. Bennani¹, A. Benelmekki¹, J. Kheyi¹, H. Bouzelmat¹, A. Chaib¹ A. Malki², N. Loudiyi², \r\nA. Zaimi², I. Asfalou², A. Benyass²’³",
        service: "1 : Service de Rythmologie du Centre de Cardiologie de l’HMIMV\r\n2 : Service des Explorations non invasives du Centre de Cardiologie de l’HMIMV\r\n3 : Chef du Centre de Cardiologie de l’HMIMV", 
        img:"assets/imgs/eposters/images/poster-49.jpg", pdf:"assets/imgs/eposters/pdfs/poster-49.pdf", 
    },
    {
        id:50, name:"",
        main_title: "STEMI and its complications during the COVID 19 era",
        all_names: "Y.FIHRI/ A.MALIKI ALAOUI/Z.LAHLAFI/N.MOUINE/Z.LAKHAL/A.BENYASS",
        service: "Cardiology Center Military Hospital Mohammed V, Rabat", 
        img:"assets/imgs/eposters/images/poster-50.jpg", pdf:"assets/imgs/eposters/pdfs/poster-50.pdf", 
    },
    {
        id:51, name:"",
        main_title: "Polymyositis complicated with Complete Atrioventricular Block A \r\ncase report and literature review",
        all_names: "K.MANOURI, N.SNOUSSI, Y.OUSSOU, H.KHARBOUCH,FZ.HATTAB,S.CHERQUI,M.CHERTI",
        service: "Service de cardiologie B, CHU Ibn Sina , RABAT", 
        img:"assets/imgs/eposters/images/poster-51.jpg", pdf:"assets/imgs/eposters/pdfs/poster-51.pdf", 
    },
    {
        id:52, name:"",
        main_title: "LES SHUNTS GAUCHE DROITE CHEZ L ADULTE : A PROPOS DE 51 CAS OPERES",
        all_names: "A.MAJDOUB, S.BOULMAKOUL, A.ELOUARDI, A.EL HAFIDI, M.MESSOUAK",
        service: "Service de chirurgie cardio vasculaire CHU HASSAN II FES", 
        img:"assets/imgs/eposters/images/poster-52.jpg", pdf:"assets/imgs/eposters/pdfs/poster-52.pdf", 
    },
    {
        id:53, name:"",
        main_title: "Endocardite Infectieuse compliquée d’une Cholécystite aigue \r\nmédicamenteuse à ceftriaxone : à propos de 3 cas",
        all_names: "K.D. AMEDIMELE, A.S. TANDIA, M. EL JAMILI , S. KARIMI , D. BENZEROUAL, M EL HATTAOUI",
        service: "Service de cardiologie, CHU Mohammed VI de MARRAKECH, MAROC", 
        img:"assets/imgs/eposters/images/poster-53.jpg", pdf:"assets/imgs/eposters/pdfs/poster-53.pdf", 
    },
    {
        id:57, name:"",
        main_title: "INFARCTUS DU MYOCARDE DE TOPOGRAPHIE INFERIEURE MASQUE\r\n PAR UNE HYPOTHYROÏDIE INFRACLINIQUE",
        all_names: "N.SNOUSSI, Y.OUSSOU, K.MANOURI, FZ. ELHATTAB, J. ZARZUR, M. CHERTI",
        service: "Service de cardiologie B, CHU ibn Sina , Rabat", 
        img:"assets/imgs/eposters/images/poster-57.jpg", pdf:"assets/imgs/eposters/pdfs/poster-57.pdf", 
    },
    {
        id:58, name:"",
        main_title: "Perforation d’anévrysme de la valve mitrale postérieure : \r\nComplication rare de l’endocardite d’un cas clinique",
        all_names: "N.SNOUSSI, Y.OUSSOU, K.MANOURI, FZ. EL HATTAB, L. HARA, J, ZARZUR, M. CHERTI",
        service: "Service de cardiologie B, CHU ibn Sina , Rabat", 
        img:"assets/imgs/eposters/images/poster-58.jpg", pdf:"assets/imgs/eposters/pdfs/poster-58.pdf", 
    },
    {
        id:59, name:"",
        main_title: "EVALUATION DE L’INTERVALLE Tp e ET RAPPORT Tp e /QT CORRIGE\r\n CHEZ LES PATIENTS DIABETIQUES DE TYPE 2 .",
        all_names: "H. CHOUKRANI S.ABOURADI. A.KHERRAF , H . ZAHIDI ,G.MINKO, A.DRIGHIL , L.AZZOUZI, R.HABBAL",
        service: "Cardiologie, CHU IBN ROCHD, CASABLANCA", 
        img:"assets/imgs/eposters/images/poster-59.jpg", pdf:"assets/imgs/eposters/pdfs/poster-59.pdf", 
    },
    {
        id:61, name:"",
        main_title: "A PUZZLING CASE OF PERICARDIAL EFFUSION WITH CHYLOTHORAX",
        all_names: "S.HILAL, R.JENNANE, S.KADDAF, J.E.SRAIRI, N . FELLAT, R. FELLAT",
        service: "Cardiac intensive care unit Department of Cardiology A Ibn Sina Hospital Rabat", 
        img:"assets/imgs/eposters/images/poster-61.jpg", pdf:"assets/imgs/eposters/pdfs/poster-61.pdf", 
    },
    {
        id:62, name:"",
        main_title: "Acute Coronary Syndrome in Chronic Renal Failure patients, \r\nwhat’s particular: about 45 cases",
        all_names: "FAID.S NADIF.M LAKTIB N. BRITEL.D LAHLAFI Z. FELIOUNI H. LOUDIYI N. BOUZERDA.A , LAKHAL.Z. \r\nMOUINE N . ASFALOU I. RAISSOUNI M. BENYASS A.",
        service: "Cardiology department at the military hospital of Mohamed V of Rabat", 
        img:"assets/imgs/eposters/images/poster-62.jpg", pdf:"assets/imgs/eposters/pdfs/poster-62.pdf", 
    },
    {
        id:63, name:"",
        main_title: "Myocarditis as a rare revealing mode of acute Q fever: A dreadful \r\nmatter to consider",
        all_names: "FAID.S NADIF.M KADDAF.S OUHARAKATE.Y .BRITEL.D LAHLAFI.Z . BOUZERDA.A, \r\nLAKHAL.Z. MOUINE N. RAISSOUNI M. BENYASS A.",
        service: "Service of Cardiology at the military Hospital of Mohamed V of Rabat", 
        img:"assets/imgs/eposters/images/poster-63.jpg", pdf:"assets/imgs/eposters/pdfs/poster-63.pdf", 
    },
    {
        id:67, name:"",
        main_title: "Profil épidémiologique et clinico microbiologique des endocardites\r\n infectieuses au CHU Mohammed VI",
        all_names: "H.NABAWI , O .BENLAFKIH , S.EL KARIMI , M.EL HATTAOUI",
        service: "Service de cardiologie CHU MOHAMMED VI, MARRAKECH", 
        img:"assets/imgs/eposters/images/poster-67.jpg", pdf:"assets/imgs/eposters/pdfs/poster-67.pdf", 
    },
    {
        id:68, name:"",
        main_title: "FOCUS ON EXCEPTIONAL RIGHT SIDED INFECTIVE ENDOCARDITIS IN \r\nPULMONARY STENOSIS:CASE REPORT AND REVIEW OF LITERATURE",
        all_names: "Dr MESMOUDI.B1 ; Dr FAID.S 1 ; Dr EZZAHRAOUI.R 1 ; Dr KADDAF.S 1 ; Dr NADIF.M 1 ; PR MOUINE.N\r\n1 ; PR RAISSOUNI.M 1 ; PR ASFALOU.I 1 ; PR BENYASS.A 1",
        service: "DEPARTMENT OF CARDIOLOGY, MILITARY HOSPITAL MOHAMMED V, RABAT", 
        img:"assets/imgs/eposters/images/poster-68.jpg", pdf:"assets/imgs/eposters/pdfs/poster-68.pdf", 
    },
    {
        id:69, name:"",
        main_title: "HUGHES STOVIN SYNDROME WITH AN INTRACARDIAC THROMBUS:\r\nAN UNUSUAL PRESENTATION OF A RARE DISEASE",
        all_names: "Dr MESMOUDI.B1 ; Dr NGUADI.J 1 ; Dr JENNANE.R 1 ; Dr RAOUI.J 1 ; Pr FATIHI.J²;PrMOUINE.N 1 ;\r\nPr ASFALOU.I 1 ; Pr BENYASS.A 1",
        service: "1-DEPARTMENT OF CARDIOLOGY, MILITARY HOSPITAL MOHAMMED V, RABAT\r\n2-DEPARTMENT OF INTERNAL MEDICINE, MILITARY HOSPITAL MOHAMMED V, RABAT", 
        img:"assets/imgs/eposters/images/poster-69.jpg", pdf:"assets/imgs/eposters/pdfs/poster-69.pdf", 
    },
    {
        id:70, name:"",
        main_title: "Connaissances, attitudes et pratique du don d’organes au Maroc: Etude transversale",
        all_names: "Youssra Amekran 1 , Abdelkader Jalil El Hangouche 1,2",
        service: "1 Laboratoire de physiologie, Faculté de médecine et de pharmacie\r\n de Tanger, Université Abdelmalek Essaadi , Maroc\r\n2 Equipe de physiologie de l’exercice et système nerveux autonome «EPE SNA», Faculté de médecine et de pharmacie de Rabat, Univers ité Mohamed V, Maroc", 
        img:"assets/imgs/eposters/images/poster-70.jpg", pdf:"assets/imgs/eposters/pdfs/poster-70.pdf", 
    },
    {
        id:71, name:"",
        main_title: "Syndrome de BEZOLD JARISCH : à propos d’un cas",
        all_names: "A.Maliki Alaoui, Y.Fihri , N.Loudeyi , N.Mouine , A.Benyass²",
        service: "1.Chef de service de cardiologie clinique et de réadaptation cardiaque, HMIMV Rabat\r\n2.Chef du centre de cardiologie, HMIMV Rabat,", 
        img:"assets/imgs/eposters/images/poster-71.jpg", pdf:"assets/imgs/eposters/pdfs/poster-71.pdf", 
    },
    {
        id:74, name:"",
        main_title: "ANOMALIE DE NAISSANCE CORONAIRE :Cas d'une angioplastie après \r\nune chirurgie de pontage",
        all_names: "NADIF.M KADDAF.S GOUBE.P",
        service: "SERVICE DE CARDIOLOGIE ,CENTRE HOSPITALIER SUD FRANCILIEN , PARIS , FRANCE", 
        img:"assets/imgs/eposters/images/poster-74.jpg", pdf:"assets/imgs/eposters/pdfs/poster-74.pdf", 
    },
    {
        id:75, name:"",
        main_title: "Contusion myocardique : cause rare d‘infarctus du myocarde",
        all_names: "NADIF.M , KADDAF.S , BERTHIER .R ,GOUBE.P",
        service: "SERVICE DE CARDIOLOGIE ,CENTRE HOSPITALIER SUD FRANCILIEN , PARIS , FRANCE", 
        img:"assets/imgs/eposters/images/poster-75.jpg", pdf:"assets/imgs/eposters/pdfs/poster-75.pdf", 
    },
    {
        id:76, name:"",
        main_title: "Allongement de l’intervalle QT chez les patients COVID 19 sous\r\n Hydroxychloroquine et Azithromycine Expérience de l’Hôpital U\r\n niversitaire Cheikh Zaid Rabat",
        all_names: "RAHMI Mouna , EL MIRE Wafaa , TAZI MEZALEK Amale , OBTEL Majdouline , BENYASS Aatif",
        service:"", 
        img:"assets/imgs/eposters/images/poster-76.jpg", pdf:"assets/imgs/eposters/pdfs/poster-76.pdf", 
    },
    {
        id:79, name:"",
        main_title: "Post partum Spontaneous Coronary Artery Dissection and aortic \r\ndissection presenting concomitantly: case report",
        all_names: "kenza Zniber , Sofia Kaddaf , Pascal Goube",
        service:"", 
        img:"assets/imgs/eposters/images/poster-79.jpg", pdf:"assets/imgs/eposters/pdfs/poster-79.pdf", 
    },
    {
        id:80, name:"",
        main_title: "EMBOLIE PULMONAIRE AU COURS D'UNE MALADIE INFLAMMATOIRE CHRONIQUE DE L INTESTIN (MICI): à propos d' un cas",
        all_names: "L.IBRAHIM; O.FARAH; F HASSAN; M. ABDELALI; B.ABAKAR; Z.LAKHAL",
        service: "CENTRE DE CARDIOLOGIE Hôpital Militaire d'Instruction Mohamed V Rabat", 
        img:"assets/imgs/eposters/images/poster-80.jpg", pdf:"assets/imgs/eposters/pdfs/poster-80.pdf", 
    },
    {
        id:81, name:"",
        main_title: "Infective endocarditis in adult with silent Patent ductus arteriosus",
        all_names: "O. Farah, L. Ibrahim, H. El Jid , D.A. Djibril , J. Rhissassi , R.Amri , M. Cherti", 
        img:"assets/imgs/eposters/images/poster-81.jpg", pdf:"assets/imgs/eposters/pdfs/poster-81.pdf", 
    },
    {
        id:83, name:"",
        main_title: "A RARE CASE OF COMPLETE HEART BLOCK IN A YOUNG PATIENT",
        all_names: "S. HILAL, R. JENNANE, N. SALMI, I. FELLAT ,M. CHERTI",
        service: "Service de Cardiologie B Hôpital Maternité Souissi", 
        img:"assets/imgs/eposters/images/poster-83.jpg", pdf:"assets/imgs/eposters/pdfs/poster-83.pdf", 
    },
    {
        id:84, name:"",
        main_title: "Impact of anticoagulation on the risk of stroke in patients with \r\ninfectious endocarditis at Ibn Rochd Casablanca University Hospital",
        all_names: "M.El MOUSAID, A.KHERRAF, A.EL AMRAOUI , S.AROUS, G.BENOUNA, A.DRIGHIL, L.AZZOUZI, R.HABBAL",
        service: "Cardiology Department, Hospital University Ibn Rochd , Casablanca, Morocco", 
        img:"assets/imgs/eposters/images/poster-84.jpg", pdf:"assets/imgs/eposters/pdfs/poster-84.pdf", 
    },
    {
        id:85, name:"",
        main_title: "ENDOCARDITE INFECTIEUSE ET EMBOLIE CORONAIRE (A PROPOS D’UN CAS)",
        all_names: "Noellie AKPABIE, Mouna RAHMI, Wafa ELMIRE, Mustapha RAHALI, Rochde SAYAH, Moha ARJI,\r\nAatif BENYASS",
        service: "Hôpital universitaire international CHEIKH ZAID\r\nHôpital Militaire dInstruction Mohamed V", 
        img:"assets/imgs/eposters/images/poster-85.jpg", pdf:"assets/imgs/eposters/pdfs/poster-85.pdf", 
    },
    {
        id:86, name:"",
        main_title: "KYSTE HYDATIQUE CARDIAQUE A PRPOS D’UN CAS",
        all_names: "W. EL MIRE, A.TAZI MEZALEK, M.RAHMI, M.AOUDAD, K.MARZOUKI, R.AJAJA, R.JAKAMY, A.BENYASS",
        service: "Hôpital universitaire international CHEIKH ZAID\r\nHôpital Militaire dInstruction Mohamed V", 
        img:"assets/imgs/eposters/images/poster-86.jpg", pdf:"assets/imgs/eposters/pdfs/poster-86.pdf", 
    },
    {
        id:87, name:"",
        main_title: "SPONTANEOUS RUPTURE OF RIGHT AORTIC SINUS OF VALSALVA\r\n LEADING TO MASSSIVE CYSTIC DISSECTION OF INTERVENTRICULAR SEPTUM AND COMPLETE HEART BLOCK",
        all_names: "W. Louizi , H. Belhoussine , H. Fennich, N. Doghmi , M. Cherti",
        service: "Cardiology B department of CHU Ibn Sina", 
        img:"assets/imgs/eposters/images/poster-87.jpg", pdf:"assets/imgs/eposters/pdfs/poster-87.pdf", 
    }
]


  constructor() { }

  getAllPosters(){
    return this.eposters;
  }

}
